var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataView',{attrs:{"context":_vm.context,"defaultCheckedCols":_vm.checkedCols,"defaultCheckedMetrics":_vm.checkedMetrics,"fixedColumns":_vm.fixedColumns,"plotMetrics":_vm.plotMetrics,"initialTemplate":_vm.template,"defaultSort":_vm.defaultSort,"back":parseInt(_vm.back)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ff606fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fraud.vue
// module id = null
// module chunks = 